import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Label from "../ui/Label";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import Card from "../ui/Card";


export default function NoteIndicators(props) {

    const { controller = "", callback = () => { }, route = "" } = props;

    const [selected, setSelected] = useState(0);
    
    const indicators = [
        {
            label: "^^",
            value: "^^",
            description: <> Tells BM to record sale but do not adjust OH. <br /> Use to sell product that never has an OH (i.e not received). </>
        },
        {
            label: "//%20",
            value: "//%",
            description: <> Applies the number after the % as a discount in POS. <br /> Use to automatically discount an item </>
        },
        {
            label: "//$5.99",
            value: "//$",
            description: <> In POS, BM uses the price after the $ instead of the regular price. <br /> Used for temporary sale. </>
        },
        {
            label: "//@4.99",
            value: "//@",
            description: <> In POS, the regular price and this price will be displayed and the clerk must pick one. Used when same product has multiple prices. </>
        },
        {
            label: "//?",
            value: "//?",
            description: <> Alert the user when the item is canned (e.g. to find a lost item that <br /> needs a class, title, ISBN correction) </>
        },
         {
            label: "//SOS",
            value: "//SOS",
            description: <> Strict-On-Sale: Title is not to be avail/sold before the PubDate</>
        },
        {
            label: "-$",
            value: "-$",
            description: <> POS price entered will be changed to a negative 'promotion' value</>
        },
        {
            label: "[text]",
            value: "[]",
            description: <> 2nd location. Labels will show this text next to the author</>
        },

    ];


    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: () => callback() },
            { key: KBD.ARROW_DOWN, action: () => { setSelected(prev => Math.min(prev + 1, indicators.length - 1) ); } },
            { key: KBD.ARROW_UP, action: () => { setSelected(prev => Math.max(prev - 1, 0) ); } },
            { key: KBD.ENTER, action: () => { setSelected(prev => { callback(indicators[prev]); return prev; }); } }
        ];

        const cleanup = listen(controller, route, actions, false);
        return cleanup;
    }, []);


    const drawIndicators = () => {

        return (
            <div style={{ "padding": "5px", "width": "560px" }}>
                {/* <Card> */}
                 {indicators.map((item, index) => (
                    <div key={item.value}>
                        <Card
                            style={{"cursor" : "pointer"}}
                            className={ index === (selected) ? "ui-card-highlight" : "" }
                            onClick={() => { setSelected(index);  }}
                            onDoubleClick={() => { callback(index);  }}
                        >
                            <Space size={10}>
                                <div></div>
                                <Label style={{ width: "50px", textAlign: "center" }} className="text" >
                                    {item.label}
                                </Label>
                                <Divider vertical />
                                <Label style={{ textAlign: "left", lineHeight: "18px" }} >
                                    {item.description}
                                </Label>
                            </Space>
                        </Card>
                        <div className="shim" />
                    </div>
                ))}



            </div>
        )
    }

    return (<><Popup title={"Notes field special indicators"} width={"auto"} callback={callback} component={drawIndicators()} /></>)
}